// Action creators for the clawback rules slice.
// One shared factory, one line per action.

import * as types from '../../lib/actionTypes.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

export var getClawbackRulesRequest = creator(types.GET_CLAWBACK_RULES_REQUEST);
export var getClawbackRulesSuccess = creator(types.GET_CLAWBACK_RULES_SUCCESS);
export var getClawbackRulesFailed = creator(types.GET_CLAWBACK_RULES_FAILURE);

export var getClawbackRuleRequest = creator(types.GET_CLAWBACK_RULE_REQUEST);
export var getClawbackRuleSuccess = creator(types.GET_CLAWBACK_RULE_SUCCESS);
export var getClawbackRuleFailed = creator(types.GET_CLAWBACK_RULE_FAILURE);

export var createClawbackRuleRequest =
  creator(types.CREATE_CLAWBACK_RULE_REQUEST);
export var createClawbackRuleSuccess =
  creator(types.CREATE_CLAWBACK_RULE_SUCCESS);
export var createClawbackRuleFailed =
  creator(types.CREATE_CLAWBACK_RULE_FAILURE);
export var resetCreateClawbackRuleSuccess =
  creator(types.RESET_CREATE_CLAWBACK_RULE_SUCCESS);
export var resetCreateClawbackRuleError =
  creator(types.RESET_CREATE_CLAWBACK_RULE_ERROR);

export var updateClawbackRuleRequest =
  creator(types.UPDATE_CLAWBACK_RULE_REQUEST);
export var updateClawbackRuleSuccess =
  creator(types.UPDATE_CLAWBACK_RULE_SUCCESS);
export var updateClawbackRuleFailed =
  creator(types.UPDATE_CLAWBACK_RULE_FAILURE);
export var resetUpdateClawbackRuleSuccess =
  creator(types.RESET_UPDATE_CLAWBACK_RULE_SUCCESS);
export var resetUpdateClawbackRuleError =
  creator(types.RESET_UPDATE_CLAWBACK_RULE_ERROR);

// Payload: { policy_clawback_formulas, symbols, sample_symbols_values } —
// nested in period blocks, unlike the commission equivalent.
export var validateClawbackRuleRequest =
  creator(types.VALIDATE_CLAWBACK_RULE_REQUEST);
export var validateClawbackRuleSuccess =
  creator(types.VALIDATE_CLAWBACK_RULE_SUCCESS);
export var validateClawbackRuleFailed =
  creator(types.VALIDATE_CLAWBACK_RULE_FAILURE);
export var resetValidateClawbackRule =
  creator(types.RESET_VALIDATE_CLAWBACK_RULE);

// Symbols produced by commission rules (gross_commission_amount and friends),
// offered as autocomplete and treated as defined during chain validation.
export var getClawbackSymbolsRequest =
  creator(types.GET_CLAWBACK_SYMBOLS_REQUEST);
export var getClawbackSymbolsSuccess =
  creator(types.GET_CLAWBACK_SYMBOLS_SUCCESS);
export var getClawbackSymbolsFailed =
  creator(types.GET_CLAWBACK_SYMBOLS_FAILURE);

export var setClawbackRuleToEdit = creator(types.SET_CLAWBACK_RULE_TO_EDIT);
export var resetClawbackRuleToEdit = creator(types.RESET_CLAWBACK_RULE_TO_EDIT);
